<mat-expansion-panel>
  <mat-expansion-panel-header collapsedHeight="60px" expandedHeight="70px">
    <mat-panel-title><h4 class="!mb-0">Brug for hjælp?</h4></mat-panel-title>
  </mat-expansion-panel-header>
  <mat-accordion class="example-headers-align" multi>
    <mat-expansion-panel>
      <mat-expansion-panel-header collapsedHeight="50px">
        <mat-panel-title><h6 class="!mb-0">Hjælp til søgning</h6></mat-panel-title>
      </mat-expansion-panel-header>
      <p class="!mb-0">
        1. Du kan søge efter telefonnr., e-mailadresse, Visma kundenr. og kundenavn <br/>
        2. Tryk enter for at sætte første søgeresultat på bonen <br/>
        3. Brug pil ned/ tab for at navigere i resultaterne - eller tryk på skærmen for at vælge et andet resultat
      </p>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title><h6 class="!mb-0">Hjælp til oprettelse af ny kunde</h6></mat-panel-title>
      </mat-expansion-panel-header>
      <p class="!mb-0">
        1. Tryk på “Opret kunde”<br/>
        2. Udfyld minimum telefonnr. og e-mailadresse.<br/>
        3. Kunden får en SMS med et link til at tilføje et kodeord og evt. rette telefonnr. og navn.<br/>
        4. Det er pt. ikke muligt at ændre en e-mailadresse efter oprettelse.<br/>
        5. Der kun oprettes én kunde pr. e-mailadresse
      </p>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title><h6 class="!mb-0">Hvis du ser en fejlbesked</h6></mat-panel-title>
      </mat-expansion-panel-header>
      <p class="!mb-0">
        Hvis systemet giver en fejlbesked, bliver der sendt en fejlrapport. Giv gerne team IT et kald og fortæl, hvad der skete, og hvad du gjorde - kontekst gør det nemmere for os at løse fejlen og evt. hjælpe dig videre.
      </p>
    </mat-expansion-panel>
  </mat-accordion>
</mat-expansion-panel>
